import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const handleCallback = async () => {
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            const errorParam = searchParams.get('error');

            if (errorParam) {
                setError('Authentication failed. Please try again.');
                setLoading(false);
                return;
            }

            if (!code) {
                setError('No authorization code received.');
                setLoading(false);
                return;
            }

            try {
                // Send the authorization code to your backend
                const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/oauth-callback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        code,
                        provider: state, // 'google' or 'github'
                        redirectUri: `${window.location.origin}/auth/callback`
                    }),
                });

                if (!response.ok) {
                    throw new Error('Authentication failed');
                }

                const data = await response.json();
                
                // Use the AuthContext login method
                login(data.token, data.user);

                // Redirect to welcome page
                navigate('/welcome');

            } catch (err) {
                setError('Failed to complete authentication. Please try again.');
                setLoading(false);
            }
        };

        handleCallback();
    }, [searchParams, navigate, login]);

    if (loading) {
        return (
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <Card className="border-0 shadow">
                            <Card.Body className="p-5 text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <h4 className="mt-3">Completing authentication...</h4>
                                <p className="text-muted">Please wait while we set up your account.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <Card className="border-0 shadow">
                            <Card.Body className="p-5">
                                <Alert variant="danger">
                                    {error}
                                </Alert>
                                <div className="text-center">
                                    <button 
                                        className="btn btn-primary"
                                        onClick={() => navigate('/signup')}
                                    >
                                        Try Again
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    return null;
};

export default AuthCallback;
